import { createTestSimpleSupplyPoint, COMPONENT_KINDS, FEEDER_KINDS, SupplyComponent } from '../types/SimpleSupplyPoint';
import { SimpleElectricalService } from '../modules/panel';

/**
 * Simple SupplyPoint test ve proof of concept
 */
export class SimpleSupplyPointTest {

  /**
   * Temel fonksiyonaliteyi test et
   */
  static runBasicTests() {
    
    

    // 1. Test data oluştur
    const simpleSupply = createTestSimpleSupplyPoint();

    
    
    

    // 2. Validation test
    const errors = simpleSupply.validate();
    
    if (errors.length === 0) {
      
    } else {
      
    }

    // 3. Relationship tests
    

    const meterPanel = simpleSupply.getComponent("component_meter_panel");
    
    

    const distPanel = simpleSupply.getComponent("component_dist_panel");
    const upstream = simpleSupply.getUpstreamComponents(distPanel.id);
    

    return simpleSupply;
  }

  /**
   * Electrical calculation test
   */
  static runElectricalTests() {
    
    

    const simpleSupply = createTestSimpleSupplyPoint();

    // 1. Individual component tests
    

    simpleSupply.components.forEach(component => {
      const electrical = SimpleElectricalService.calculateComponentElectrical(component.id, simpleSupply);
      
    });

    // 2. Feeder calculations
    

    simpleSupply.feeders.forEach(feeder => {
      const electrical = SimpleElectricalService.calculateFeederElectrical(feeder.id, simpleSupply);
      const fromComponent = simpleSupply.getComponent(feeder.from);
      const toComponent = simpleSupply.getComponent(feeder.to);

      
    });

    // 3. Upstream chain test
    

    const distPanel = simpleSupply.getComponent("component_dist_panel");
    const upstreamResults = SimpleElectricalService.calculateUpstreamChain(distPanel.id, simpleSupply);

    upstreamResults.forEach(result => {
      const component = simpleSupply.getComponent(result.componentId);
      
    });

    return simpleSupply;
  }

  /**
   * Dynamic load addition test
   */
  static runDynamicLoadTest() {
    
    

    const simpleSupply = createTestSimpleSupplyPoint();

    // Başlangıç durumu
    
    const initialResults = SimpleElectricalService.recalculateAllComponents(simpleSupply);

    // Yeni load ekle
    

    const newLoad = new SupplyComponent({
      id: "component_load_001",
      kind: COMPONENT_KINDS.LOAD,
      name: "Yeni Yük 500W",
      electrical: {
        installedPower: 500,
        demandPower: 500,
        current: 2.3
      },
      metadata: {
        loadType: "socket"
      }
    });

    simpleSupply.components.push(newLoad);

    // Load'ı dist panel'e bağla
    const distPanel = simpleSupply.getComponent("component_dist_panel");
    distPanel.outgoingFeeders.push("feeder_branch_001");

    // Feeder ekle
    const branchFeeder = {
      id: "feeder_branch_001",
      from: "component_dist_panel",
      to: "component_load_001",
      type: "branch",
      kind: FEEDER_KINDS.BRANCH_CIRCUIT,
      power: { installedPower: 500, demandPower: 500, current: 2.3 },
      cable: { type: "NYM", section: 2.5, length: 10 }
    };

    simpleSupply.feeders.push(branchFeeder);

    // Load relationship güncelle
    newLoad.incomingFeeders = ["feeder_branch_001"];

    // Yeniden hesapla
    
    const updatedResults = SimpleElectricalService.recalculateAllComponents(simpleSupply);

    // Değişiklikleri karşılaştır
    

    const compare = (componentName, initial, updated) => {
      const initialResult = initial.find(r => {
        const comp = simpleSupply.getComponent(r.componentId);
        return comp?.name === componentName;
      });

      const updatedResult = updated.find(r => {
        const comp = simpleSupply.getComponent(r.componentId);
        return comp?.name === componentName;
      });

      if (initialResult && updatedResult) {
        const powerChange = updatedResult.electrical.installedPower - initialResult.electrical.installedPower;
        
      }
    };

    compare("ZKT", initialResults, updatedResults);
    compare("Sayaç Panosu", initialResults, updatedResults);
    compare("ŞEBEKE", initialResults, updatedResults);

    return simpleSupply;
  }

  /**
   * Performance comparison test
   */
  static runPerformanceTest() {
    
    

    const simpleSupply = createTestSimpleSupplyPoint();

    // Çok sayıda component ekle
    

    for (let i = 0; i < 50; i++) {
      const load = new SupplyComponent({
        id: `component_load_${i}`,
        kind: COMPONENT_KINDS.LOAD,
        name: `Load ${i}`,
        electrical: { installedPower: Math.random() * 1000 + 100 }
      });
      simpleSupply.components.push(load);
    }

    

    // Performance test
    const startTime = performance.now();

    for (let i = 0; i < 100; i++) {
      SimpleElectricalService.recalculateAllComponents(simpleSupply);
    }

    const endTime = performance.now();
    const avgTime = (endTime - startTime) / 100;

    
    
    
    

    return avgTime;
  }

  /**
   * Tüm testleri çalıştır
   */
  static runAllTests() {
    
    

    try {
      // 1. Basic tests
      const basicTestResult = this.runBasicTests();

      // 2. Electrical tests
      const electricalTestResult = this.runElectricalTests();

      // 3. Dynamic load test
      const dynamicTestResult = this.runDynamicLoadTest();

      // 4. Performance test
      const performanceResult = this.runPerformanceTest();

      
      
      
      
      
      

      return {
        success: true,
        basicTest: basicTestResult,
        electricalTest: electricalTestResult,
        dynamicTest: dynamicTestResult,
        performanceMs: performanceResult
      };

    } catch (error) {
      console.error("❌ TEST FAILED:", error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

// Browser console'da kullanım için global export
if (typeof window !== 'undefined') {
  window.SimpleSupplyPointTest = SimpleSupplyPointTest;
}